"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wedge = void 0;

var Factory_1 = require("../Factory");

var Shape_1 = require("../Shape");

var Global_1 = require("../Global");

var Validators_1 = require("../Validators");

var Global_2 = require("../Global");

var Wedge = /*#__PURE__*/function (_Shape_1$Shape) {
  _inherits(Wedge, _Shape_1$Shape);

  var _super = _createSuper(Wedge);

  function Wedge() {
    _classCallCheck(this, Wedge);

    return _super.apply(this, arguments);
  }

  _createClass(Wedge, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      context.beginPath();
      context.arc(0, 0, this.radius(), 0, Global_1.Konva.getAngle(this.angle()), this.clockwise());
      context.lineTo(0, 0);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.radius() * 2;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.radius() * 2;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.radius(width / 2);
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.radius(height / 2);
    }
  }]);

  return Wedge;
}(Shape_1.Shape);

exports.Wedge = Wedge;
Wedge.prototype.className = 'Wedge';
Wedge.prototype._centroid = true;
Wedge.prototype._attrsAffectingSize = ['radius'];
(0, Global_2._registerNode)(Wedge);
Factory_1.Factory.addGetterSetter(Wedge, 'radius', 0, (0, Validators_1.getNumberValidator)());
Factory_1.Factory.addGetterSetter(Wedge, 'angle', 0, (0, Validators_1.getNumberValidator)());
Factory_1.Factory.addGetterSetter(Wedge, 'clockwise', false);
Factory_1.Factory.backCompat(Wedge, {
  angleDeg: 'angle',
  getAngleDeg: 'getAngle',
  setAngleDeg: 'setAngle'
});